<template>
    <span class="identifier-badge" :title="title || undefined">
        <span class="identifier-badge__icon" aria-hidden="true">
            <svg-vue class="identifier-badge__hash" icon="font-awesome.regular.hashtag"></svg-vue>
        </span>
        <span class="identifier-badge__value">{{ value }}</span>
    </span>
</template>

<script>
export default {
    name: 'IdentifierBadge',

    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.identifier-badge {
    display: inline-flex;
    align-items: stretch;
    min-width: 1.75rem;
    min-height: 1.5rem;
    padding: 0;
    overflow: hidden;
    border: 1px solid var(--ui-border-default);
    border-radius: 0.25rem;
    background-color: #ffffff;
    color: var(--ui-text-subtle);
    flex: 0 0 auto;
    font-size: 0.6875rem;
    font-weight: 500;
    line-height: 1rem;
    vertical-align: middle;
}

.identifier-badge__icon,
.identifier-badge__value {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 1.5rem;
    background-color: #ffffff;
}

.identifier-badge__icon {
    min-width: 1.5rem;
    padding: 0 0.3rem;
}

.identifier-badge__hash {
    width: 0.625rem;
    height: 0.625rem;
}

.identifier-badge__value {
    padding: 0.2rem 0.35rem;
    border-left: 1px solid var(--ui-border-default);
}
</style>
